export default "__VITE_ASSET__fnwgJ5YX__"